import React from "react";
import Modal from "../../../../elements/Modal";
import ScholarshipMessage from "../ScholarshipMessage";
import ScholarshipStatus from "../ScholarshipStatus";

const ScholarshipStatusModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="xl2" title={"Change Status"}>
      <ScholarshipStatus getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ScholarshipStatusModal;
